import * as React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import raws from '@/data/healthatwork.json'

const { facebook: FACEBOOK, instagram: INSTAGRAM, youtube: YOUTUBE } = raws.social

interface ImageQueryData {
	facebook: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
	instagram: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
	youtube: {
		childImageSharp: {
			gatsbyImageData: IGatsbyImageData;
		}
	}
}

const Logo: React.FC = () => {
	const data = useStaticQuery<ImageQueryData>(graphql`
		query SocialImagesQuery {
			facebook: file(relativePath: { eq: "social/facebook.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
			instagram: file(relativePath: { eq: "social/instagram.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
			youtube: file(relativePath: { eq: "social/youtube.png" }) {
				childImageSharp {
					gatsbyImageData(
						placeholder: NONE
						layout: CONSTRAINED
					)
				}
			}
		}
	`)

	const facebookLogo = getImage(data.facebook)
	const instagramLogo = getImage(data.instagram)
	const youtubeLogo = getImage(data.youtube)

	return (
		<div className="flex gap-6">
			{[
				{ href: FACEBOOK, image: facebookLogo, alt: 'facebook-logo' },
				{ href: INSTAGRAM, image: instagramLogo, alt: 'instagram-logo' },
				{ href: YOUTUBE, image: youtubeLogo, alt: 'youtube-logo' }
			].map((item) => (
				<a
					key={ item.alt }
					href={ item.href }
					target="_blank"
					rel="noopener noreferrer"
				>
					<GatsbyImage
						image={ item.image as IGatsbyImageData }
						alt={ item.alt }
						className="h-8 w-8 hover:opacity-75 duration-200"
					/>
				</a>
			)) }
		</div>
	)
}

export default Logo
